import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import createMutationsSharer from 'vuex-shared-mutations'
import MEISHIBANK2 from 'static/config'

Vue.use(Vuex)

/**
 * データストアの保存先設定
 */
const vuexLocal = new VuexPersistence({
  key: MEISHIBANK2.storage.key,
  storage: window.localStorage,
  // #632 複数タブで状態をキープしない場合はfilterでfalseを返す（デフォルトはtrue）
  filter: (mutation) => {
    return mutation.type !== 'setTab' && mutation.type !== 'delTab'
  }
})

/**
 * データストア（vuex）
 * アプリ全体の状態を保持するために使用する
 */
const initState = {
  // 同一ブラウザ内共通データ
  base: {
    debug: MEISHIBANK2.debug,
    token: '',
    code: '',
    sidc: '',
    service_version: '',
    service_name: '',
    service_owner: '',
    service_url: '',

    // ログインでリセットさせない情報
    perm: {
      l: {
        isR: false,
        c: '',
        l: '',
        w: ''
      }
    },

    /**
     * 画面上のUIを制御する情報
     * u:
     *    v-if, computed, watchでgetState('login_user')を使っていると
     *    データの変更をキャッチしてくれないので、$store.state.base.uを監視する
     *    ようすにるためのプロパティ
     * headerInfoReloader:
     *    ヘッダーお知らせリローダー
     * headerAnnouncementsReloader:
     *    ヘッダー運営からのお知らせリローダー
     * sidemenuReloader:
     *    サイドバー情報リローダー
     * bcardListReloader:
     *    一覧リローダー（新規追加、更新された場合などに発生）
     * isListSortMode:
     *    表示順変更中かどうか
     * intervals:
     *    setIntervalしたものたちで終了期限がないものはここにいれる
     * files:
     *    input filesの代わり
     * tab:
     *    tab: 表示するタブ名
     *    tabData: タブに送る追加データ
     *    bcard: 名刺情報
     *    isOpen: 開閉フラグ
     *    isDeleted: 削除フラグ
     * listMode:
     *    名刺一覧の表示モード
     */
    u: 1,
    headerInfoReloader: false,
    headerAnnouncementsReloader: false,
    sidemenuReloader: false,
    bcardListReloader: false,
    isListSortMode: false,
    flashMessages: [],
    intervals: [],
    files: [],
    tab: {},
    listMode: ''
  },
  // [企業コード][会社ID]で区切ったデータを置く場所
  corps: {
  }
}
// [企業コード][会社ID]の下に置くデータ
const defaultCorpState = {
  license: [],
  login_user: [],

  // 一覧画面から引き継ぐ検索条件
  // 同機能ないで画面遷移後に、一覧画面の検索条件を復活させるため
  // TODO [次期]一覧画面内にさらに一覧があった場合（モーダル内とか）は配列の後ろに追加してよい？
  listConds: {
    pagination: {},
    conditions: {}
  },
  // 検索条件（名刺検索用）
  searchConds: {
    pagination: {},
    conditions: {}
  },
  // // 検索条件（名刺照会用）
  // bcardsConds: {
  //   exchanged: {
  //     pagination: {},
  //     conditions: {}
  //   },
  //   accessed: {
  //     pagination: {},
  //     conditions: {}
  //   },
  //   updated: {
  //     pagination: {},
  //     conditions: {}
  //   },
  //   favorited: {
  //     pagination: {},
  //     conditions: {}
  //   }
  // },

  isMgmt: false
}

const storeUtils = function (store) {
  store.resetState = function () {
    let base = this.state.base
    let corps = this.state.corps
    // ログインでリセットさせない情報を一旦回避
    const perm = base.perm
    // リセット
    base = JSON.parse(JSON.stringify(initState))
    base.perm = JSON.parse(JSON.stringify(perm))
    if (corps[base.code]) {
      corps[base.code][base.sidc] = JSON.parse(JSON.stringify(defaultCorpState))
    }
    return Object.assign(
      JSON.parse(JSON.stringify(base)),
      JSON.parse(JSON.stringify(corps))
    )
  }
  /**
   * Vueコンポーネントから使うゲッター
   * 旧：$store.state.xxx
   * 新：$store.getState('xxx')
   */
  store.getState = function (name) {
    const state = this.state
    if (name in state.base) {
      return state.base[name]
    }
    const code = state.base.code
    const sidc = state.base.sidc
    if (code && sidc && state.corps[code] && state.corps[code][sidc]) {
      return state.corps[code][sidc][name]
    }
    else {
      return defaultCorpState[name]
    }
  }
  /**
   * 共通情報を保存する
   * 旧：state[name] = value
   * 新：state.base[name] = value
   */
  store.setBaseState = function (name, value) {
    this.state.base[name] = value
  }
  /**
   * 会社ごとの情報を保存する
   * 旧：state[name] = value
   * 新：state.corps[code][sidc][name] = value
   */
  store.setCorpState = function (name, value) {
    const code = this.state.base.code
    const sidc = this.state.base.sidc
    if (code && sidc) {
      // 企業コードの階層を作る
      if (!this.state.corps[code]) {
        this.state.corps[code] = {}
      }
      // 会社IDの階層を作り、初期値をセットする
      if (!this.state.corps[code][sidc]) {
        this.state.corps[code][sidc] = JSON.parse(JSON.stringify(defaultCorpState))
      }
      this.state.corps[code][sidc][name] = value
    }
  }
}

export default new Vuex.Store({
  plugins: [
    vuexLocal.plugin,
    storeUtils,
    createMutationsSharer({ predicate: ['setToken', 'delToken'] })
  ],
  state: JSON.parse(JSON.stringify(initState)),
  getters: {
    /**
     * ログイン情報の取得
     */
    loginData (state) {
      const l = state.base.perm.l
      return l.isR ? {
        isRememberMe: l.isR,
        company_code: l.c.split('').reverse().join(''),
        loginid: l.l.split('').reverse().join(''),
        word: l.w.split('').reverse().join('')
      } : {}
    }
  },
  /**
   * getters, stateは使わないこと
   */
  actions: {
    reloadHeaderInfo (context) {
      context.commit('setHeaderInfoReloader', true)
      setTimeout(function () {
        context.commit('setHeaderInfoReloader', false)
      }, 100)
    },
    reloadHeaderAnnouncements (context) {
      context.commit('setHeaderAnnouncements', true)
      setTimeout(function () {
        context.commit('setHeaderAnnouncements', false)
      }, 100)
    },
    reloadSidemenu (context) {
      context.commit('setSidemenuReloader', true)
      setTimeout(function () {
        context.commit('setSidemenuReloader', false)
      }, 100)
    },
    reloadBcardList (context) {
      context.commit('setBcardListReloader', true)
      setTimeout(function () {
        context.commit('setBcardListReloader', false)
      }, 100)
    },
    setToken (context, token) {
      context.commit('setToken', token)
      // 最大5秒、tokenがストレージにセットされるまで待つ
      let startTime = +(new Date())
      let curTime = +(new Date()) - startTime
      let localToken = JSON.parse(localStorage.getItem(vuexLocal.key)).base.token
      while (curTime < 5000 && localToken !== token) {
        curTime = +(new Date()) - startTime
        localToken = JSON.parse(localStorage.getItem(vuexLocal.key)).base.token
      }
    }
  },
  /**
   * getters, stateは使わないこと
   */
  mutations: {
    /**
     * データのリセット
     */
    resetState (state) {
      this.resetState()
    },
    /*
     * 一覧検索条件を初期化する
     */
    initListConds (state) {
      this.setCorpState('listConds', {
        pagination: {},
        conditions: {}
      })
    },
    /**
     * 一覧検索条件を初期化する（名刺検索用）
     */
    initSearchConds (state) {
      this.setCorpState('searchConds', {
        pagination: {},
        // 初期値があるものは設定する
        conditions: {
          seltags: [],
          search_target: '0', // 初期値0: 自分が交換した名刺
          display_mode: '0', // 初期値0: 最新の名刺情報を表示
          inner_introducers: [],
          outer_introducers: []
        }
      })
    },
    // /*
    //  * 一覧検索条件を初期化する（名刺照会用）
    //  */
    // initBcardsConds (state, pageName) {
    //   let bcardsConds = this.getState('bcardsConds')
    //   // exchanged
    //   if (pageName === 'exchanged') {
    //     bcardsConds.exchanged = {
    //       pagination: {},
    //       conditions: {}
    //     }
    //   }
    //   // accessed
    //   else if (pageName === 'accessed') {
    //     bcardsConds.accessed = {
    //       pagination: {},
    //       conditions: {}
    //     }
    //   }
    //   // updated
    //   else if (pageName === 'updated') {
    //     bcardsConds.updated = {
    //       pagination: {},
    //       conditions: {}
    //     }
    //   }
    //   // favorited
    //   else if (pageName === 'favorited') {
    //     bcardsConds.favorited = {
    //       pagination: {},
    //       conditions: {}
    //     }
    //   }
    //   this.setCorpState('bcardsConds', bcardsConds)
    // },
    /**
     * 一覧検索条件を更新する
     * @param Object state 自動付与
     * @param Object payload
     *          - target: String pagination/conditions（空の場合は全体更新）
     *          - data: Object データ
     */
    setListConds (state, payload) {
      let target = payload.target
      let data = payload.data
      let listConds = this.getState('listConds')
      if (target === 'pagination') {
        listConds.pagination = data
      }
      else if (target === 'conditions') {
        listConds.conditions = data
      }
      else {
        listConds = data
      }
      this.setCorpState('listConds', listConds)
    },
    /**
     * 一覧検索条件を更新する（名刺検索用）
     * @param Object state 自動付与
     * @param Object payload
     *          - target: String pagination/conditions（空の場合は全体更新）
     *          - data: Object データ
     */
    setSearchConds (state, payload) {
      let target = payload.target
      let data = payload.data
      let searchConds = this.getState('searchConds')
      if (target === 'pagination') {
        searchConds.pagination = data
      }
      else if (target === 'conditions') {
        searchConds.conditions = data
      }
      else {
        searchConds = data
      }
      this.setCorpState('searchConds', searchConds)
    },
    // /**
    //  * 一覧検索条件を更新する（名刺照会用）
    //  * @param Object state 自動付与
    //  * @param Object payload
    //  *          - target: String pagination/conditions（空の場合は全体更新）
    //  *          - data: Object データ
    //  *          - pageName: String 機能名
    //  */
    // setBcardsConds (state, payload) {
    //   let target = payload.target
    //   let data = payload.data
    //   let bcardsConds = this.getState('bcardsConds')
    //   // exchanged
    //   if (payload.pageName === 'exchanged') {
    //     if (target === 'pagination') {
    //       bcardsConds.exchanged.pagination = data
    //     }
    //     else if (target === 'conditions') {
    //       bcardsConds.exchanged.conditions = data
    //     }
    //     else {
    //       bcardsConds.exchanged = data
    //     }
    //   }
    //   // accessed
    //   else if (payload.pageName === 'accessed') {
    //     if (target === 'pagination') {
    //       bcardsConds.accessed.pagination = data
    //     }
    //     else if (target === 'conditions') {
    //       bcardsConds.accessed.conditions = data
    //     }
    //     else {
    //       bcardsConds.accessed = data
    //     }
    //   }
    //   // updated
    //   else if (payload.pageName === 'updated') {
    //     if (target === 'pagination') {
    //       bcardsConds.updated.pagination = data
    //     }
    //     else if (target === 'conditions') {
    //       bcardsConds.updated.conditions = data
    //     }
    //     else {
    //       bcardsConds.updated = data
    //     }
    //   }
    //   // favorited
    //   else if (payload.pageName === 'favorited') {
    //     if (target === 'pagination') {
    //       bcardsConds.favorited.pagination = data
    //     }
    //     else if (target === 'conditions') {
    //       bcardsConds.favorited.conditions = data
    //     }
    //     else {
    //       bcardsConds.favorited = data
    //     }
    //   }
    //   this.setCorpState('bcardsConds', bcardsConds)
    // },
    /**
     * 機能管理モードを開始する
     * @param Object state 自動付与
     */
    startMgmtMode (state) {
      this.setCorpState('isMgmt', true)

      // セッションが更新されたかどうかのチェックに使うものなので、最後に更新する
      this.setBaseState('u', Math.random())
    },
    /**
     * 機能管理モードを終了する
     * @param Object state 自動付与
     */
    finishMgmtMode (state) {
      this.setCorpState('isMgmt', false)

      // セッションが更新されたかどうかのチェックに使うものなので、最後に更新する
      this.setBaseState('u', Math.random())
    },
    /**
     * トークンをセットする
     */
    setToken (state, token) {
      this.setBaseState('token', token)
    },
    delToken (state) {
      this.setBaseState('token', null)
    },
    /**
     * サービス情報をセットする
     */
    setInitInfo (state, initInfo) {
      this.setBaseState('code', initInfo.company_code)
      this.setBaseState('sidc', initInfo.sid_corporate)
      this.setBaseState('service_version', initInfo.service_version)
      this.setBaseState('service_name', initInfo.service_name)
      this.setBaseState('service_owner', initInfo.service_owner)
      this.setBaseState('service_owner_url', initInfo.service_owner_url)

      this.setCorpState('login_user', initInfo.login_user)
      this.setCorpState('license', initInfo.license)
      this.setCorpState('nisfa_integration', initInfo.nisfa_integration)
      this.setCorpState('attachment_max_size', initInfo.attachment_max_size)

      // セッションが更新されたかどうかのチェックに使うものなので、最後に更新する
      this.setBaseState('u', Math.random())
    },
    /**
     * flashメッセージをセットする
     * 画面遷移がある場合は、pushの後に呼んでください
     */
    setFlashMessages (state, messages) {
      this.setBaseState('flashMessages', messages)
    },
    /**
     * intervalsをセットする
     */
    setIntervals (state, interval) {
      let intervals = this.getState('intervals')
      intervals.push(interval)
      this.setBaseState('intervals', intervals)
    },
    clearIntervals (state) {
      let intervals = this.getState('intervals')
      if (intervals) {
        for (let i = intervals.length - 1; i >= 0; i--) {
          clearInterval(intervals[i])
        }
      }
      this.setBaseState('intervals', [])
    },
    /**
     * 表示順変更モードをON/OFFする
     */
    toggleListSortMode (state, isListSortMode) {
      if (typeof isListSortMode === 'undefined') {
        this.setBaseState('isListSortMode', !this.getState('isListSortMode'))
      }
      else {
        this.setBaseState('isListSortMode', isListSortMode)
      }
    },
    setFiles (state, files) {
      this.setBaseState('files', files)
    },
    delFiles (state, files) {
      this.setBaseState('files', [])
    },
    setTab (state, tab) {
      this.setBaseState('tab', tab)
    },
    delTab (state, tab) {
      this.setBaseState('tab', {})
    },
    setListMode (state, listMode) {
      this.setBaseState('listMode', listMode)
    },
    setHeaderInfoReloader (state, headerInfoReloader) {
      this.setBaseState('headerInfoReloader', headerInfoReloader)
    },
    setHeaderAnnouncements (state, headerAnnouncementsReloader) {
      this.setBaseState('headerAnnouncementsReloader', headerAnnouncementsReloader)
    },
    setSidemenuReloader (state, sidemenuReloader) {
      this.setBaseState('sidemenuReloader', sidemenuReloader)
    },
    setBcardListReloader (state, bcardListReloader) {
      this.setBaseState('bcardListReloader', bcardListReloader)
    },
    /**
     * ログイン情報の保存
     */
    setLoginData (state, loginData) {
      this.setBaseState('perm', {
        l: {
          isR: loginData.isRememberMe,
          c: loginData.company_code.split('').reverse().join(''),
          l: loginData.loginid.split('').reverse().join(''),
          w: loginData.word.split('').reverse().join('')
        }
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js